import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserSessionState } from './user-session.state';
import { RootState } from '../shared/root-state.interface';

const getUserSessionFeatureState =
  createFeatureSelector<UserSessionState>('user-session');

export const selectIsInitializing = createSelector<
  RootState,
  [UserSessionState],
  boolean
>(getUserSessionFeatureState, (state) => state.isInitializing);

export const selectIsLoggedIn = createSelector<
  RootState,
  [UserSessionState],
  boolean
>(getUserSessionFeatureState, (state) => state.isLoggedIn);

export const selectIsLoading = createSelector(
  getUserSessionFeatureState,
  (state) => state.isLoading,
);

export const selectProductsPairings = createSelector(
  getUserSessionFeatureState,
  (state) => ({
    paired: Object.values(state.pairedProducts),
    unpaired: Object.values(state.unpairedProducts),
  }),
);

export const selectAlertMessage = createSelector(
  getUserSessionFeatureState,
  (state) => ({ message: state.alertMessage, hasError: state.hasError }),
);

export const selectUserData = createSelector(
  getUserSessionFeatureState,
  (state) => ({ name: state.displayName, email: state.email }),
);

export const selectCreateUserErrors = createSelector(
  getUserSessionFeatureState,
  (state) => state.createUserErrors,
);

export const selectSuccessMessage = createSelector(
  getUserSessionFeatureState,
  (state) => state.successMessage,
);
